// Lazy-Load-Plugins (a3 Lazy Load, Lazy Load XT, WP Rocket, ...) ersetzen die
// echte Bild-URL durch einen Platzhalter und laden sie erst nach, wenn das Bild
// in den Viewport scrollt. Die Slides des Sliders liegen aber bereits im
// Viewport – sie werden nur per translateX aus dem overflow-hidden-Bereich
// geschoben. Ein Seitenwechsel loest weder Scroll- noch Resize-Event aus, also
// merkt das Plugin nichts und die Bilder bleiben leer. Deshalb loesen wir die
// Platzhalter der Zielseite vor dem Wechsel selbst auf.
const LAZY_SRC_ATTRS = ["data-src", "data-lazy-src", "data-original"];
const LAZY_SRCSET_ATTRS = ["data-srcset", "data-lazy-srcset", "data-original-set"];

function firstAttr(el, attrs) {
  for (const attr of attrs) {
    const value = el.getAttribute(attr);
    if (value) {
      return value;
    }
  }
  return null;
}

function revealImage(img) {
  const src = firstAttr(img, LAZY_SRC_ATTRS);
  if (src && img.getAttribute("src") !== src) {
    img.setAttribute("src", src);
  }

  const srcset = firstAttr(img, LAZY_SRCSET_ATTRS);
  if (srcset && img.getAttribute("srcset") !== srcset) {
    img.setAttribute("srcset", srcset);
  }

  // Natives Lazy Loading verhaelt sich bei transformierten Elementen ebenfalls
  // traege – fuer die bereits sichtbare Zielseite ist eager korrekt.
  if (img.getAttribute("loading") === "lazy") {
    img.setAttribute("loading", "eager");
  }

  // a3 Lazy Load blendet ueber .lazy-hidden { opacity: 0 } aus und setzt nach
  // dem Laden .lazy-loaded. Da wir das Laden uebernehmen, tun wir das auch.
  img.classList.remove("lazy-hidden");
  img.classList.add("lazy-loaded");
}

function revealPage(page) {
  if (!page) {
    return;
  }
  page.querySelectorAll("img").forEach(revealImage);
}

function initSlider(slider) {
  const track = slider.querySelector(".ga-referenzen-kunden-track");
  const prevButton = slider.querySelector(".ga-referenzen-kunden-prev");
  const nextButton = slider.querySelector(".ga-referenzen-kunden-next");
  const totalPages = parseInt(slider.dataset.totalPages, 10) || 1;

  if (!track || !prevButton || !nextButton) {
    return;
  }

  const pages = Array.from(track.children);
  let currentPage = 0;

  function update() {
    // Erst die Bilder aufloesen, dann schieben: so laufen Ladevorgang und
    // Transition parallel.
    revealPage(pages[currentPage]);
    track.style.transform = `translateX(-${currentPage * 100}%)`;
    prevButton.style.display = currentPage === 0 ? "none" : "flex";
    nextButton.style.display = currentPage === totalPages - 1 ? "none" : "flex";
  }

  prevButton.addEventListener("click", () => {
    if (currentPage > 0) {
      currentPage -= 1;
      update();
    }
  });

  nextButton.addEventListener("click", () => {
    if (currentPage < totalPages - 1) {
      currentPage += 1;
      update();
    }
  });
}

document.querySelectorAll(".ga-referenzen-kunden-slider").forEach(initSlider);
